import { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { api } from "../lib/api";
import { useMemberAuth } from "../lib/auth";
import EditableImage from "../components/EditableImage";

const MemberSignup = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { login } = useMemberAuth();
  const token = searchParams.get("token");
  const [state, setState] = useState({ loading: true, valid: false, email: "", name: "" });
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (!token) {
      setState({ loading: false, valid: false, email: "", name: "" });
      return;
    }
    api
      .get("/members/signup/verify", { params: { token } })
      .then((r) => setState({ loading: false, valid: true, ...r.data }))
      .catch((err) => {
        setState({ loading: false, valid: false, email: "", name: "" });
        toast.error(err.response?.data?.detail || "Invalid link");
      });
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 8) {
      toast.error("Password must be at least 8 characters");
      return;
    }
    if (password !== confirm) {
      toast.error("Passwords do not match");
      return;
    }
    setSubmitting(true);
    try {
      const { data } = await api.post("/members/signup", { token, password });
      login(data.token, { email: data.email, name: data.name });
      navigate("/members/catalog");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Could not create account");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="grid md:grid-cols-2 min-h-[80vh]" data-testid="member-signup-page">
      <div className="hidden md:block overflow-hidden">
        <EditableImage
          imageKey="member_signup"
          fallback="https://images.unsplash.com/photo-1603189343302-e603f7add05a?w=1400&q=80"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      <div className="flex items-center justify-center p-10 md:p-20">
        <div className="w-full max-w-md">
          <h1 className="font-display text-4xl uppercase tracking-tighter leading-none">Create Login</h1>

          {state.loading ? null : !state.valid ? (
            <div className="mt-8 space-y-6">
              <p className="text-sm text-black/65">
                This invitation link is invalid or expired.
              </p>
              <Link to="/hoodies" className="btn-primary" data-testid="member-signup-shop-link">Shop</Link>
            </div>
          ) : (
            <form onSubmit={submit} className="mt-10 space-y-8" data-testid="member-signup-form">
              <div className="text-sm text-black/65" data-testid="signup-email-display">
                {state.email}
              </div>
              <input
                type="password"
                required
                placeholder="Password (min 8)"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="input-bare"
                data-testid="member-signup-password"
              />
              <input
                type="password"
                required
                placeholder="Confirm password"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                className="input-bare"
                data-testid="member-signup-confirm"
              />
              <button type="submit" disabled={submitting} className="btn-primary w-full" data-testid="member-signup-submit">
                {submitting ? "..." : "Create Login"}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default MemberSignup;
